export interface ModbusFrame {
  slaveId: number;
  functionCode: number;
  data: Uint8Array;
}

export interface ModbusReadRequest {
  slaveId: number;
  functionCode: 0x03;
  startRegister: number;
  count: number;
}

export interface ModbusWriteRequest {
  slaveId: number;
  functionCode: 0x06;
  register: number;
  value: number;
}

export interface ModbusResponse {
  slaveId: number;
  functionCode: number;
  values: number[];
  exception?: number;
}

export const MODBUS_EXCEPTIONS: Record<number, string> = {
  0x01: 'Illegal Function',
  0x02: 'Illegal Data Address',
  0x03: 'Illegal Data Value',
  0x04: 'Slave Device Failure',
  0x05: 'Acknowledge',
  0x06: 'Slave Device Busy',
  0x07: 'Negative Acknowledge',
  0x08: 'Memory Parity Error',
};
